import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { firstValueFrom, map, tap } from 'rxjs';

import { ValidationService } from '../../utils/valibot/validation.service';
import { TolerantPostFCCityStreetNumberQueryOptions } from './model/request.model';
import { TolerantPostResponseModel, TolerantPostResponseModelSchema } from './model/response.model';

@Injectable({
  providedIn: 'root',
})
export class TolerantPostClient {
  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);
  private readonly validationService = inject(ValidationService);

  // interactive=false is supposed to be used when searching for multiple similiar or matching addressed.
  // This, for example, can be the case when wanting to display multiple similiar addresses to the user.
  // interactive=true is supposed to be used when validating a given address.
  resolveAddress(
    options: TolerantPostFCCityStreetNumberQueryOptions,
    interactive: boolean,
  ): Promise<{ responseStatus: number; responseBody: TolerantPostResponseModel | null }> {
    let queryParams = new HttpParams();

    Object.entries(options).forEach(([key, value]) => {
      if (value != undefined) {
        queryParams = queryParams.set(key, value as string);
      }
    });

    const url = interactive ? 'tolerant/Interactive' : 'tolerant/FCCityStreetNumber';
    this.logger.info(`${interactive ? '#CDFTF0016' : '#CDFTF0012'} Fetching for addresses ${url}`);
    return firstValueFrom(
      this.http
        .get(url, {
          params: queryParams,
          observe: 'response',
        })
        .pipe(
          tap({
            error: (error) =>
              this.logger.error(
                `${interactive ? '#CDFTF0017' : '#CDFTF0013'} Unable to fetch for addresses. Used reqId: ${options.reqId}.`,
                error,
              ),
          }),
          map((response) => {
            let returnBody: TolerantPostResponseModel | null = null;
            if (response.body) {
              returnBody = this.validationService.parseWithSchema(TolerantPostResponseModelSchema, response.body);
            }
            return { responseStatus: response.status, responseBody: returnBody };
          }),
        ),
    );
  }
}
